module.exports = __webpack_public_path__ + "2f70628e44f33a25b8e66d0f37425193.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/Passepartout.jpg
// module id = 572
// module chunks = 0